import { render, staticRenderFns } from "./NotarizationGuideReport.vue?vue&type=template&id=0705a048"
import script from "./NotarizationGuideReport.vue?vue&type=script&lang=js"
export * from "./NotarizationGuideReport.vue?vue&type=script&lang=js"
import style0 from "./NotarizationGuideReport.vue?vue&type=style&index=0&id=0705a048&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports